// Uses FileReader to read the contents of a file (from a file input callback)
// and passes the name and data URL to a callback
function readFile (files, next) {
	var file = files instanceof FileList ? files[0] : files

	if (!file) {
		next()
		return
	}

	var reader = new FileReader()
	reader.onload = function (fileEvent) {
		next(file.name, fileEvent.target.result)
	}

	reader.readAsDataURL(file)
}

export default readFile

readFile.__filename__ = 'components/read-file.js'
